import styled from "styled-components"
import { Link as DefaultLink } from "../../link/link"

export const Container = styled.div`
  padding: 80px 0px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 62px 32px;
  }
`

export const Title = styled.h4`
  color: #00A687;
  margin-bottom: 16px;
  text-align: center;

  @media (max-width: 768px) {
    font-family: Ubuntu;
    font-size: 32px;
    line-height: 36.77px;
    text-align: left;
  }
`

export const Description = styled.p`
  font-size: 24px;
  font-weight: 400;
  line-height: 27.58px;
  margin-bottom: 61px;
  padding: 0 32px;
  text-align: center;

  @media (max-width: 768px) {
    font-family: "Source Sans 3";
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 32px;
    padding: 0;
    text-align: left;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: 58px;

  & > img {
    max-height: 526px;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    img {
      display: block;
      max-width: 100%;
    }
  }
`

export const CardsWrapper = styled.div`
  display: flex;
  flex: 1 100%;
  flex-direction: column;
  gap: 16px;
`

export const Card = styled.div`
  border: 1px solid #00A687;
  border-radius: 8px;
  display: flex;
  gap: 16px;
  padding: 16px;

  & > div {
    & > h5 {
      color: #00A988;
      font-family: Source Sans 3;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
    }

    & > p {
      color: #084F43;
      font-family: Source Sans 3;
      font-size: 16px;
      line-height: 24px;
    }
  }
`

export const Link = styled(DefaultLink)`
  font-family: Ubuntu;
  font-size: 24px;
  line-height: 27.58px;
  margin-top: 46px;
  text-align: center;
  width: 60%;

  @media (max-width: 768px) {
    width: 100%;
  }
`